/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './roles.scss';
import LoadingIndicator from 'components/LoadingIndicator';
import {createRole, deleteRole, fetchRoles, updateRole} from 'actions/rolesAction';
import useScrollable from 'hooks/useScrollable';
import {NotificationManager} from 'react-notifications';
import CreateRole from './createRole';
import {isAdmin, isStaff} from '../../../utils/role';
import Block from './block';
import {useInjectSaga} from '../../../utils/injectSaga';
import rolesSaga from '../../../sagas/rolesSaga';

const Roles = () => {
  const table = useRef();
  useScrollable(table);
  useInjectSaga({key: 'role', saga: rolesSaga});
  const rolesFromAPI = useSelector((state) => state.roles);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [create, setCreate] = useState(false);
  const [newRole, setNewRole] = useState({
    title: '',
    color: '',
    description: '',
  });
  const dispatch = useDispatch();

  // handle role change
  // const handleChange = (
  //   roles,
  //   type,
  //   role,
  //   rolePermission,
  //   checked,
  //   setAllRoles,
  // ) => {
  //   // const newRoles = [...roles];
  //   // const singeRole = newRoles.find(f => f.title === role.title);
  //   // const getType = (obj, value) => {
  //   //   obj[type] = value;
  //   //   return obj;
  //   // };
  //   // const newPermission = singeRole.permissions.map(p =>
  //   //    p.pageFolderId === rolePermission.pageFolderId &&
  //   //     p.type === rolePermission.type
  //   //     ? getType({ ...p }, checked)
  //   //     : p,
  //   // );
  //   // singeRole.permissions = newPermission;
  //   // const changedRoles = [...newRoles].map(r =>
  //   //   r.title === singeRole.title ? singeRole : r,
  //   // );
  //   //
  //   // dispatch(updateRole(singeRole._id, singeRole));
  //   // setAllRoles(changedRoles);
  // };

  // const getPermissions = role => {
  //   // get all type of dynamic roles
  //   const dynamicRoles = Object.values(RoleTypes);
  //   const permissions = dynamicRoles.reduce((list, dynamicRole) => {
  //     const pagePermissions = folders.reduce((permissionList, folder) => {
  //       if (dynamicRole === 'COMPANY' && folder.type !== 'COMPANY') {
  //         return permissionList;
  //       }
  //
  //       if (dynamicRole === 'INFORMATION' && folder.type !== 'INFORMATION') {
  //         return permissionList;
  //       }
  //
  //       let permission = role.permissions.find(
  //         p => p&& p.pageFolderId === folder.title && p.type === dynamicRole
  //       );
  //
  //       if (permission) {
  //         if (permission.type === 'POST') {
  //           if (folder.title !== 'about' && folder.title !== 'partner' && folder.title !== 'profile' && folder.title !== 'team') {
  //             permissionList.push(permission);
  //           }
  //         } else {
  //           permissionList.push(permission);
  //         }
  //       } else if (dynamicRole === 'POST') {
  //         if (folder.title !== 'about' && folder.title !== 'partner' && folder.title !== 'profile' && folder.title !== 'team') {
  //           permissionList.push({
  //             edit: false,
  //             pageFolderId: folder.title,
  //             publish: false,
  //             view: false,
  //             type: dynamicRole,
  //           });
  //         }
  //       } else {
  //         permissionList.push({
  //           edit: false,
  //           pageFolderId: folder.title,
  //           publish: false,
  //           view: false,
  //           type: dynamicRole,
  //         });
  //       }
  //       return permissionList;
  //     }, []);
  //     return [...list, ...pagePermissions];
  //   }, []);
  //
  //   const staticPermissions = Object.values(AdminRolesTypes).reduce(
  //     (list, current) => {
  //       Object.values(AdminRolesFolders[current]).forEach(folder => {
  //         const permission = role.permissions.find(
  //           p => p&& p.pageFolderId === folder && p.type === current,
  //         );
  //
  //         if (permission) {
  //           list.push(permission);
  //         } else {
  //           list.push({
  //             edit: false,
  //             pageFolderId: folder,
  //             publish: false,
  //             view: false,
  //             type: current,
  //           });
  //         }
  //       });
  //       return list;
  //     },
  //     [],
  //   );
  //   return [...permissions, ...staticPermissions];
  // };

  useEffect(() => {
    dispatch(fetchRoles());
  }, []);

  useEffect(() => {
    if (rolesFromAPI.createFailed) {
      NotificationManager.success('Role updated failed!', ``);
    } else if (rolesFromAPI.fetchSuccess) {
      setRoles(rolesFromAPI.roles);
    } else if (rolesFromAPI.createSuccess) {
      NotificationManager.success('Role updated success!', ``);
    }

    setPermissions(rolesFromAPI.permissions);
  }, [rolesFromAPI]);

  const handleChange = (role, action, type) => {
    setRoles([]);
    const pp = permissions.find((p) => p.action === action && p.type === type);

    if (!pp) return;
    if (role.permissions.includes(pp._id)) {
      role.permissions.splice(role.permissions.indexOf(pp._id), 1);
    } else {
      role.permissions.push(pp._id);
    }
    setRoles([...roles]);
    dispatch(updateRole(role._id, {permissions: role.permissions}));
  };

  return (
    <>
      <div className="dashboard-list roles-table p-3">
        <div className="d-inline-block role-section">
          <CreateRole
            role={newRole}
            setRole={setNewRole}
            isOpened={create}
            onClose={() => setCreate(false)}
            onSave={() => {
              if (newRole._id) {
                dispatch(
                  updateRole(newRole._id, {
                    title: newRole.title,
                    description: newRole.description,
                    color: newRole.color,
                  })
                );
                setCreate(false);
              } else if (
                newRole.title &&
                !roles.find((r) => r.title === newRole.title)
              ) {
                dispatch(createRole(newRole));
                setCreate(false);
              }
            }}
          />
          {roles ? (
            roles
              .filter((r) => isStaff([r]) && !isAdmin([r]))
              .map((role, i) => (
                <div key={i}>
                  <div className="download-icon d-flex align-items-center">
                    <h6 className="text-center w-100">{role.title}</h6>
                    <span
                      className="align-self-end w-25"
                      onClick={() => {
                        setNewRole({...role});
                        setCreate(true);
                      }}
                    >
                      edit icon
                    </span>
                    <span
                      className="align-self-end w-25"
                      onClick={() => {
                        dispatch(deleteRole(role._id));
                      }}
                    >
                      delete icon
                    </span>
                  </div>
                  {[3, 2, 1].map((i) => (
                    <React.Fragment key={i}>
                      <div className="w-100">
                        {[0, 1, 2, 3, 4, 5, 6].map((j) => {
                          const no = i + j * 3;
                          const p = permissions.find((p) => p.no === no);
                          return (
                            <Block
                              key={`${i}-${j}`}
                              role={role}
                              permission={p}
                              id={no}
                              selected={p && role.permissions.includes(p._id)}
                              onUpdatePermission={() => {
                                if (p) handleChange(role, p.action, p.type);
                              }}
                            />
                          );
                        })}
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              ))
          ) : (
            <LoadingIndicator />
          )}
          <div className="download-icon d-flex align-items-center">
            <h6
              className="text-center w-100"
              onClick={() => {
                setNewRole({
                  title: '',
                  color: '',
                  description: '',
                });
                setCreate(true);
              }}
            >
              Create new role{' '}
            </h6>
          </div>
        </div>
        <div className="d-inline-block role-info-section float-right">
          <div className="download-icon d-flex align-items-center">
            <h6 className="text-center w-100">NOTES</h6>
          </div>
          <div className="w-100">
            <table className="table table-striped">
              <thead>
                <tr>
                  <td>01 NO : Can not see Navigation POST in left sidebar</td>
                </tr>
                <tr>
                  <td>
                    01 YES : Can see Navigation POST in left sidebar, can see 2
                    tabs (ARCHITECTURES/INTERIORS) on the top, with post list
                  </td>
                </tr>
                <tr>
                  <td>
                    02 NO : Can not click 5 buttons
                    (lock/edit/move/clone/delete)
                  </td>
                </tr>
                <tr>
                  <td>
                    02 YES : Can click 5 buttons (lock/edit/move/clone/delete)
                    and can open single project edit page
                  </td>
                </tr>
                <tr>
                  <td>
                    03 NO : Can only click button on EDITOR BOARD, and leave
                    message on TEAM CHAT
                  </td>
                </tr>
                <tr>
                  <td>
                    03 YES : Can click EDITOR BOARD, leave message on TEAM CHAT,
                    can click MANAGER BOARD
                  </td>
                </tr>
                <tr>
                  <td>04 NO : Can not see Navigation POST in left sidebar</td>
                </tr>
                <tr>
                  <td>
                    04 YES : Can see Navigation POST in left sidebar, can see 4
                    tabs (CONSTRUCTIONS/ELECTRONICS/FURNITURE/GOODS)
                  </td>
                </tr>
                <tr>
                  <td>
                    05 NO : Can not click 5 buttons
                    (lock/edit/move/clone/delete)
                  </td>
                </tr>
                <tr>
                  <td>
                    05 YES : Can click 5 buttons (lock/edit/move/clone/delete)
                    and can open single product edit page
                  </td>
                </tr>
                <tr>
                  <td>
                    06 NO : Can only click button on EDITOR BOARD, and leave
                    message on TEAM CHAT
                  </td>
                </tr>
                <tr>
                  <td>
                    06 YES : Can click EDITOR BOARD, leave message on TEAM CHAT,
                    can click MANAGER BOARD
                  </td>
                </tr>
                <tr>
                  <td>
                    07 NO : Can not see Navigation COMPANY in left sidebar
                  </td>
                </tr>
                <tr>
                  <td>
                    07 YES : Can see Navigation COMPANY in left sidebar, can see
                    1 tabs (PROFILE) on the top with profile list
                  </td>
                </tr>
                <tr>
                  <td>08 NO : Can not edit COMPANY profile (edit/delete)</td>
                </tr>
                <tr>
                  <td>
                    08 YES : Can edit COMPANY profile (edit/delete) and open
                    single profile list
                  </td>
                </tr>
                <tr>
                  <td>09 NO : Can not see Tab (ABOUT) on the tops</td>
                </tr>
                <tr>
                  <td>
                    09 YES : Can see Tab (ABOUT) on the tops with about list
                  </td>
                </tr>
                <tr>
                  <td>
                    10 NO : Can not click 5 buttons
                    (lock/edit/move/clone/delete)
                  </td>
                </tr>
                <tr>
                  <td>
                    10 YES : Can click 5 buttons (lock/edit/move/clone/delete)
                    and can open single ABOUT edit page
                  </td>
                </tr>
                <tr>
                  <td>
                    11 NO : Can only click button on EDITOR BOARD, and leave
                    message on TEAM CHAT
                  </td>
                </tr>
                <tr>
                  <td>
                    11 YES : Can click EDITOR BOARD, leave message on TEAM CHAT,
                    can click MANAGER BOARD
                  </td>
                </tr>
                <tr>
                  <td>12 NO : Can not see Tab (PARTNER) on the tops</td>
                </tr>
                <tr>
                  <td>
                    12 YES : Can see Tab (PARTNER) on the tops with partner list
                  </td>
                </tr>
                <tr>
                  <td>
                    13 NO : Can not mark/edit company status (partner/member)
                  </td>
                </tr>
                <tr>
                  <td>
                    13 YES : Can mark/edit company status (partner/member) to
                    show if company is our really partner
                  </td>
                </tr>
                <tr>
                  <td>14 NO : Can not see temporary folder in Cloud</td>
                </tr>
                <tr>
                  <td>14 YES : Can see temporary folder in Cloud</td>
                </tr>
                <tr>
                  <td>
                    15 NO : Can not see Navigation INFORMATION in left sidebar
                  </td>
                </tr>
                <tr>
                  <td>
                    15 YES : Can see Navigation INFORMATION in left sidebar, can
                    see 6 tabs on the top, with post list
                  </td>
                </tr>
                <tr>
                  <td>
                    16 NO : Can not click 5 buttons
                    (lock/edit/move/clone/delete)
                  </td>
                </tr>
                <tr>
                  <td>
                    17 NO : Can only click button on EDITOR BOARD, and leave
                    message on TEAM CHAT
                  </td>
                </tr>
                <tr>
                  <td>
                    17 YES : Can click EDITOR BOARD, leave message on TEAM CHAT,
                    can click MANAGER BOARD
                  </td>
                </tr>
                <tr>
                  <td>
                    18 NO : Can not see Navigation CATEGORY
                    (POST/COMPANY/INFORMATION) in left sidebar
                  </td>
                </tr>
                <tr>
                  <td>
                    18 YES : Can see Navigation CATEGORY
                    (POST/COMPANY/INFORMATION) in left sidebar with each Tabs
                  </td>
                </tr>
                <tr>
                  <td>
                    19 NO : Can not edit Category (The mouse left and right
                    buttons do not respond)
                  </td>
                </tr>
                <tr>
                  <td>
                    19 YES : Can edit Category (by clicking mouse left/right
                    button)r
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
